import React from 'react';
import { observer } from 'mobx-react';
import { useViewerControl } from 'libs/rendering/gltf/hooks';
import { useClientStore } from 'apps/hooks';

import Icon from 'components/Icon';
import Heading from 'components/Heading';
import Twix from 'components/Twix';
import Button from 'components/Button';
import Tooltip from 'components/Tooltip';

import { UiModes } from '../../config';

import ResizePanel from './resizePanel';

import {
  MessagePane,
  PanelStyled,
  PanelHeaderMainWrapper,
  TitleWrapper,
  BlockWrapper,
  IconWrapper,
  ButtonCollapse,
  TooltipWrapper,
  CloseButtonWrapper,
} from './panel.styled';

const Panel = observer(function _Panel(props) {
  const viewerControl = useViewerControl();
  const clientStore = useClientStore();

  const {
    position,
    leftPanelState,
    title,
    iconName,
    viewBox,
    children,
    footer,
    isOpen,
  } = props;

  // alias collapseAction
  const collapseAction = () => {
    if (leftPanelState) leftPanelState.Collapse();
    else if (props.collapseAction) props.collapseAction();
    else viewerControl?.UpdateUiMode(UiModes.collapsed);
  };

  const CloseButton = () =>
    props.addCloseButton ? (
      <CloseButtonWrapper>
        <Button
          outline
          size='small'
          variant='minimal'
          icon='close_small'
          ariaLabel='close panel'
          onClick={collapseAction}
        />
      </CloseButtonWrapper>
    ) : null;

  const PanelHeader = () =>
    !props.removeHeader ? (
      <>
        {title && (
          <PanelHeaderMainWrapper position={position}>
            {iconName && (
              <IconWrapper>
                <Icon name={iconName} viewBox={viewBox} />
              </IconWrapper>
            )}
            <TitleWrapper>
              <Heading level='3' size='small'>
                {title}
              </Heading>
            </TitleWrapper>

            <BlockWrapper onClick={collapseAction}>
              <TooltipWrapper>
                <Tooltip delayShow={500} place='right' id='tooltipTab' />
              </TooltipWrapper>
              {/* <ButtonCollapse */}
              {/*  icon={position === 'left' ? 'collapse' : 'collapse_right'} */}
              {/*  ariaLabel='Collapse Tab' */}
              {/*  size='xsmall' */}
              {/*  variant='secondary' */}
              {/*  data-tip='Collapse' */}
              {/*  data-place='right' */}
              {/*  data-for='tooltipTab' */}
              {/* /> */}
            </BlockWrapper>
          </PanelHeaderMainWrapper>
        )}
      </>
    ) : null;

  /*
    FIXME: below causes {children} to be remounted
    const DefaultPanel = () => (
      <PanelStyled
        position={position}
        isOpen={isOpen}
        large={props.large}
        chatVisible={props.chatVisible}
      >
        <PanelHeader />
        <CloseButton />
        {children}
        {footer}
      </PanelStyled>
    );
  */

  return (
    <Twix breakingPoint='medium'>
      <PanelStyled
        position={position}
        isOpen={isOpen}
        large={props.large}
        chatVisible={props.chatVisible}
        width='auto'
        overrideLeftToZero={!clientStore.signedInProfile}
      >
        <PanelHeader />
        {children}
        <MessagePane id='message-pane'>{footer}</MessagePane>
      </PanelStyled>
      <>
        {leftPanelState ? (
          <ResizePanel
            position={position}
            isOpen={isOpen}
            storedLeftPanelWidth={leftPanelState.leftPanelResizeWidth}
            updateOutsideWidthSize={leftPanelState.SetLeftPanelResizeWidth}
          >
            <PanelHeader />
            {children}
            {footer}
          </ResizePanel>
        ) : (
          <PanelStyled
            position={position}
            isOpen={isOpen}
            large={props.large}
            chatVisible={props.chatVisible}
          >
            <PanelHeader />
            <CloseButton />
            {children}
            {footer}
          </PanelStyled>
        )}
      </>
    </Twix>
  );
});

export default Panel;
